import { Events,ProductViewContext } from "../types";

import { submitSPEvents } from "./emitSnowplowEvent";

export function emitProductView({
  offer_id,
  source_position,
  source_type,
  source_id,
}: ProductViewContext["options"]) {
  submitSPEvents<ProductViewContext>([
    {
      context: Events.PRODUCT_VIEW,
      options: {
        offer_id,
        source_position,
        source_type,
        source_id,
      },
    },
  ]);
}
